(() => {
    class Resources {
        load(file, type, format = '') {
            return new Promise((resolve, reject) => {
                const element   = document.createElement('link');
                element.rel = 'preload';
                element.as  = type;
                // Important success and error for the promise
                element.onload  = () => {
                    this.unload(element);
                    resolve(file);
                }
                element.onerror = () => {
                    this.unload(element);
                    reject('Error loading resource: ' + file);
                }
                const cache_bust = type === 'image' ? '' : '?' + App.Setting('cache_bust');
                // Inject into document to kick off loading
                element.href = this.getPathByType(type) + file + format + cache_bust;
                document.head.appendChild(element);
            });
        }
        getPathByType(type) {
            switch (type) {
                case 'script':
                    return '/assets/js/';
                case 'style':
                    return '/assets/css/';
                default:
                    return '';
            }
        }
        unload(e) {
            e.parentElement.removeChild(e);
        }
        css(file)   { return this.load(file, 'style', '.css') }
        js(file)    { return this.load(file, 'script', '.js') }
        image(file) { return this.load(file, 'image') }
        font(file)  { return this.load(file, 'font') }
    }
    App.Interface.Resources = new Resources();
})();